import classNames from 'classnames';
import React, { ComponentProps } from 'react';
import CurrencyFormat from 'react-currency-format';
import styles from './PercentageIndicator.module.scss';

type PercentageIndicatorProps = {
  value: number;
  prefix?: string;
  suffix?: string;
  invert?: boolean;
} & ComponentProps<'input'>;

const PercentageIndicator = ({ value, prefix, suffix, invert = false, className }: PercentageIndicatorProps) => {
  const isNeutral = value === 0;
  const isPositive = value > 0;

  return (
    <CurrencyFormat
      className={classNames(styles['indicator'], className, {
        [styles['indicator-positive']]: invert ? !isPositive : isPositive,
        [styles['indicator-negative']]: invert ? isPositive : !isPositive,
        [styles['indicator-neutral']]: isNeutral,
      })}
      value={value}
      displayType="text"
      decimalScale={1}
      prefix={prefix || isNeutral ? '' : isPositive ? '+ ' : '- '}
      suffix={suffix}
      allowNegative={false}
      fixedDecimalScale
    />
  );
};

export default PercentageIndicator;
